export default class Modal {
  _modalElement = null
  _modalBody = null
  _placeholder = null
  _originalParent = null

  static show(title, message) {
    const content = document.createElement('div')
    content.className = 'text-center py-4'
    content.innerHTML = `
      <h3 class="text-xl font-bold title-color mb-3">${title}</h3>
      <p class="text-gray-600 mb-6">${message}</p>
      <button class="buttonComponent small w-full modal-ok-btn">D'accord</button>
    `
    const modal = new Modal()
    modal.open(content)

    const btn = content.querySelector('.modal-ok-btn')
    if (btn) btn.onclick = () => modal.close()
  }

  static confirm(title, message) {
    return new Promise((resolve) => {
      const content = document.createElement('div')
      content.className = 'text-center py-4'
      content.innerHTML = `
        <h3 class="text-xl font-bold title-color mb-3">${title}</h3>
        <p class="text-gray-600 mb-6">${message}</p>
        <div class="flex gap-3">
          <button class="px-4 py-2 border border-gray-200 text-gray-700 rounded-full flex-1 hover:bg-gray-50 transition-colors modal-cancel-btn">Annuler</button>
          <button class="buttonComponent small flex-1 modal-confirm-btn">Confirmer</button>
        </div>
      `
      const modal = new Modal()
      modal.open(content)

      const cancelBtn = content.querySelector('.modal-cancel-btn')
      const confirmBtn = content.querySelector('.modal-confirm-btn')

      if (cancelBtn)
        cancelBtn.onclick = () => {
          modal.close()
          resolve(false)
        }
      if (confirmBtn)
        confirmBtn.onclick = () => {
          modal.close()
          resolve(true)
        }
    })
  }

  open(contentRef) {
    // Créer le modal si ce n'est pas déjà fait
    if (!this._modalElement) {
      this._modalElement = document.createElement('div')
      this._modalElement.className = `
        fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-[100]
        modal-overlay
      `
      this._modalElement.innerHTML = `
        <div class="bg-white rounded-2xl p-8 max-w-[400px] w-[90%] max-h-[80%] overflow-auto shadow-2xl relative modal-content">
          <button class="absolute top-4 right-4 text-gray-400 hover:text-gray-600 modal-close transition-colors">✕</button>
          <div class="modal-body"></div>
        </div>
      `
      document.body.appendChild(this._modalElement)

      this._modalBody = this._modalElement.querySelector('.modal-body')

      // Listeners pour fermer
      this._modalElement
        .querySelector('.modal-close')
        .addEventListener('click', () => this.close())
      this._modalElement.addEventListener('click', (e) => {
        if (e.target === this._modalElement) this.close()
      })
    }

    // Sauvegarder position originale (si c'est un noeud DOM existant)
    if (contentRef instanceof HTMLElement && contentRef.parentNode) {
      this._originalParent = contentRef.parentNode
      this._placeholder = document.createElement('div')
      this._originalParent.insertBefore(this._placeholder, contentRef)
      this._modalBody.appendChild(contentRef)
    } else if (contentRef instanceof HTMLElement) {
      this._modalBody.innerHTML = ''
      this._modalBody.appendChild(contentRef)
    } else {
      this._modalBody.innerHTML = contentRef
    }

    this._modalElement.style.display = 'flex'
    document.body.style.overflow = 'hidden'
  }

  close() {
    if (!this._modalElement) return

    if (this._originalParent && this._placeholder) {
      const contentRef = this._modalBody.firstChild
      if (contentRef) {
        this._originalParent.insertBefore(contentRef, this._placeholder)
        this._placeholder.remove()
      }
      this._placeholder = null
      this._originalParent = null
    }

    this._modalElement.style.display = 'none'
    document.body.style.overflow = ''
  }
}
